import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'
import { adminBeneficiaryVettingList } from './actions/admin_beneficiary_vetting'
import AdminCommonListLayout from 'admin/components/layout/AdminCommonListLayout'
import { Tooltip } from '@material-ui/core'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import Timestamp from 'components/Timestamp'
import { getVettingPath } from './actions/admin_revetting'
import { Edit } from '@material-ui/icons'

export default function AdminBeneficiaryVettingHistory({ company_id }) {
  const history = useHistory()
  const dispatch = useDispatch()
  const is_loading = useSelector(() => adminBeneficiaryVettingList.isLoading())

  useEffect(() => {
    if (!company_id) {
      return
    }
    dispatch(adminBeneficiaryVettingList.invalidateList())
    dispatch(adminBeneficiaryVettingList.updateListFilter({ company_ref: company_id, status: 'all' }))
    dispatch(adminBeneficiaryVettingList.fetchListIfNeeded())

    return () => {
      dispatch(adminBeneficiaryVettingList.clearListFilter())
    }
  }, [dispatch, company_id])

  const onUpdateListOrdering = (field) => {
    dispatch(adminBeneficiaryVettingList.updateListOrdering(field))
  }

  const handleRowClick = (vettingId) => {
    history.push(getVettingPath(vettingId))
  }

  const renderStatus = (status) => {
    let statusColor = ''
    switch (status) {
      case 'approved':
      case 'Approved':
        statusColor = 'green'
        break
      case 'vetting_in_progress':
      case 'Vetting in Progress':
        statusColor = 'orange'
        break
      case 'declined':
      case 'Declined':
        statusColor = 'red'
        break
      default:
        statusColor = 'gray'
    }

    const label = status && typeof status === 'string' ? status.replace(/_/g, ' ') : status
    return (
      <Tooltip arrow title={label}>
        <FiberManualRecordIcon style={{ color: statusColor }} />
      </Tooltip>
    )
  }

  const columns = [
    {
      field: 'company_legal_name',
      title: 'Organisation',
      render: (item) => (
        get(item, 'company_legal_name', '')
          ? <a onClick={() => handleRowClick(item.id)}>{get(item, 'company_legal_name')}</a>
          : '---'
      ),
      sort: (direction) => onUpdateListOrdering(direction === 'asc' ? 'company_legal_name' : '-company_legal_name'),
    },
    {
      field: 'company_website',
      title: 'Website',
      render: (item) => get(item, 'company_website', '') || '---',
    },
    {
      field: 'status',
      title: 'Status',
      render: (item) => renderStatus(get(item, 'status')),
      sort: (direction) => onUpdateListOrdering(direction === 'asc' ? 'status' : '-status'),
    },
    {
      field: 'created_at',
      title: 'Created at',
      render: (item) => (item.created_at ? <Timestamp value={item.created_at} /> : '---'),
      sort: (direction) => onUpdateListOrdering(direction === 'asc' ? 'created_at' : '-created_at'),
    },
    {
      field: 'modified_at',
      title: 'Modified at',
      render: (item) => (item.modified_at ? <Timestamp value={item.modified_at} /> : '---'),
      sort: (direction) => onUpdateListOrdering(direction === 'asc' ? 'modified_at' : '-modified_at'),
    },
    {
      field: 'approved_at',
      title: 'Approval Date',
      render: (item) => (item.approved_at ? <Timestamp value={item.approved_at} /> : '---'),
      sort: (direction) => onUpdateListOrdering(direction === 'asc' ? 'approved_at' : '-approved_at'),
    },
  ]

  if (!company_id) {
    return (
      <div style={{ padding: 24 }}>
        <p>Save the beneficiary with a company first to view vetting history.</p>
      </div>
    )
  }

  const viewVettingRecord = [
          {
              icon: <Edit />,
              tooltip: 'View',
              onClick: (rowData) => history.push(getVettingPath(rowData.id))
          }
      ]

  return (
    <AdminCommonListLayout
      as_table
      extra_content_top={<div style={{ height: 18 }} />}
      is_loading={is_loading}
      columns={columns}
      item_list={adminBeneficiaryVettingList}
      additionalRowActions={viewVettingRecord}
      canDelete={false}
    />
  )
}
